export default __webpack_public_path__ + "d5d1abd0744acca7d7042eff91374011.svg";